import { useState, useEffect } from "react";

export default function EmailPopup() {
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("email_collected")) return;
    if (sessionStorage.getItem("email_dismissed")) return;
    const t = setTimeout(() => setVisible(true), 8000);
    return () => clearTimeout(t);
  }, []);

  const handleSubmit = () => {
    if (!email || !email.includes("@")) return;
    localStorage.setItem("email_collected", email);
    setSubmitted(true);
    setTimeout(() => { setVisible(false); }, 3000);
  };

  const handleDismiss = () => {
    sessionStorage.setItem("email_dismissed", "1");
    setVisible(false);
    setDismissed(true);
  };

  if (!visible || dismissed) return null;

  return (
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.75)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px"}}>
      <div style={{background:"linear-gradient(135deg,#1a0533,#2d0a5e)",borderRadius:"24px",border:"2px solid rgba(168,85,247,0.4)",padding:"40px 36px",maxWidth:"420px",width:"100%",textAlign:"center",position:"relative",boxShadow:"0 0 60px rgba(139,44,226,0.4)"}}>
        
        {/* Close */}
        <button onClick={handleDismiss} style={{position:"absolute",top:"14px",right:"16px",background:"transparent",border:"none",color:"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:"1.3rem",lineHeight:1}}>✕</button>

        {!submitted ? (
          <>
            {/* Icon */}
            <div style={{fontSize:"3rem",marginBottom:"12px"}}>🎁</div>
            
            {/* Title */}
            <h2 style={{color:"white",fontWeight:"bold",fontSize:"1.5rem",marginBottom:"8px",lineHeight:1.2}}>Get Exclusive Casino Bonuses!</h2>
            <p style={{color:"rgba(255,255,255,0.55)",fontSize:"0.85rem",marginBottom:"8px"}}>Join 50,000+ players getting weekly exclusive offers, free spins & no deposit bonuses straight to their inbox.</p>

            {/* Offer highlight */}
            <div style={{background:"rgba(255,200,0,0.1)",border:"1px solid rgba(255,200,0,0.3)",borderRadius:"12px",padding:"12px",marginBottom:"20px"}}>
              <div style={{color:"#ffd700",fontWeight:"bold",fontSize:"1rem"}}>🎰 Sign up bonus: 50 Free Spins</div>
              <div style={{color:"rgba(255,255,255,0.4)",fontSize:"0.75rem",marginTop:"4px"}}>Exclusive for new subscribers</div>
            </div>

            {/* Email input */}
            <input
              type="email"
              placeholder="Enter your email address..."
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleSubmit()}
              style={{width:"100%",padding:"12px 16px",borderRadius:"12px",border:"1px solid rgba(168,85,247,0.4)",background:"rgba(255,255,255,0.05)",color:"white",fontSize:"0.9rem",marginBottom:"12px",outline:"none",boxSizing:"border-box"}}
            />

            {/* Submit */}
            <button onClick={handleSubmit} style={{width:"100%",background:"linear-gradient(135deg,#a855f7,#7c3aed)",color:"white",border:"none",borderRadius:"12px",padding:"13px",fontWeight:"bold",fontSize:"1rem",cursor:"pointer",boxShadow:"0 0 20px rgba(168,85,247,0.4)",letterSpacing:"0.5px"}}>
              🎁 Claim My Free Spins →
            </button>

            <p style={{color:"rgba(255,255,255,0.25)",fontSize:"0.68rem",marginTop:"12px"}}>No spam. Unsubscribe anytime. 18+ only.</p>
          </>
        ) : (
          <>
            <div style={{fontSize:"3rem",marginBottom:"16px"}}>🎉</div>
            <h2 style={{color:"#ffd700",fontWeight:"bold",fontSize:"1.4rem",marginBottom:"8px"}}>You're In!</h2>
            <p style={{color:"rgba(255,255,255,0.6)",fontSize:"0.9rem"}}>Check your inbox for your 50 Free Spins bonus. Welcome to PlaySpiro!</p>
          </>
        )}
      </div>
    </div>
  );
}
